import React from "react";
import moment from "moment";
import { numberWithCommas, switchDotsAndCommas } from "../../util/utilFunction";

const formatAngka = (value) => {
  if (value === null || value === undefined || value === "") return "-";
  return switchDotsAndCommas(numberWithCommas(value));
};

function getWeekOfMonth(dateStr) {
  const date = moment(dateStr, "YYYY-MM-DD");
  const startOfMonth = date.clone().startOf("month");
  const firstWeekStart = startOfMonth.clone().startOf("isoWeek");

  const diffDays = date.diff(firstWeekStart, "days");
  const weekNumber = Math.floor(diffDays / 7) + 1;

  return weekNumber > 4 ? 4 : weekNumber;
}

function hitungBahanPerWeek(jadwalKirim = [], berat = 0, runner = 0) {
  const totalPerWeek = { 1: 0, 2: 0, 3: 0, 4: 0 };

  jadwalKirim.forEach((jadwal) => {
    if (!jadwal?.date || !jadwal?.jumlah) return;
    const week = getWeekOfMonth(jadwal.date);
    totalPerWeek[week] += jadwal.jumlah;
  });

  return {
    week1: (totalPerWeek[1] * (berat + runner)) / 1000,
    week2: (totalPerWeek[2] * (berat + runner)) / 1000,
    week3: (totalPerWeek[3] * (berat + runner)) / 1000,
    week4: (totalPerWeek[4] * (berat + runner)) / 1000,
  };
}

function getPemakaianPerWeek(pemakaianMaterial) {
  const p = pemakaianMaterial || {};
  return {
    week1: (p.week1 ?? 0) / 1000,
    week2: (p.week2 ?? 0) / 1000,
    week3: (p.week3 ?? 0) / 1000,
    week4: (p.week4 ?? 0) / 1000,
  };
}

function getSelisihInfo(forecast, aktual, stockAwal) {
  const awal = stockAwal ? stockAwal : 0;
  const selisih = forecast - awal - aktual;

  if (selisih === 0) {
    return {
      selisih,
      style: { ...tdStyle, background: "#e6f7e6", color: "#217a21" },
    };
  }

  if (selisih < 0) {
    return {
      selisih,
      style: { ...tdStyle, background: "#fddede", color: "#a30000" },
    };
  }

  return {
    selisih,
    style: { ...tdStyle, background: "#fff3cd", color: "#7a5c00" },
  };
}

const thStyle = {
  border: "1px solid #d0d0d0",
  padding: "8px 10px",
  background: "#f2f2f2",
  fontSize: "13px",
  textAlign: "center",
  whiteSpace: "nowrap",
};

const thForecastGroupStyle = {
  ...thStyle,
  background: "#bcdcf7",
  color: "#0b4a80",
  fontWeight: 700,
};

const thForecastStyle = {
  ...thStyle,
  background: "#e3f0fb",
};

const thUsageGroupStyle = {
  ...thStyle,
  background: "#ffd9a8",
  color: "#7a4200",
  fontWeight: 700,
};

const thUsageStyle = {
  ...thStyle,
  background: "#fff1de",
};

const thSelisihGroupStyle = {
  ...thStyle,
  background: "#d9d9d9",
  color: "#333333",
  fontWeight: 700,
};

const tdStyle = {
  border: "1px solid #e0e0e0",
  padding: "6px 10px",
  fontSize: "13px",
  textAlign: "right",
};

const tdForecastStyleAdaStock = {
  ...tdStyle,
  background: "#bfebbf",
};

const tdForecastStyle = {
  ...tdStyle,
  background: "#eef6fd",
};

const tdUsageStyle = {
  ...tdStyle,
  background: "#fff6ea",
};

const tdUsageMutedStyle = {
  ...tdUsageStyle,
  color: "#b0a08a",
};

const tdCenterStyle = { ...tdStyle, textAlign: "center" };
const tdLeftStyle = { ...tdStyle, textAlign: "left", whiteSpace: "nowrap" };

const MrpTable = ({ data }) => {
  if (!data || data.length === 0) {
    return <p style={{ marginTop: "12px" }}>Tidak ada data.</p>;
  }

  const seenMaterials = new Set();

  return (
    <div style={{ overflowX: "auto", marginTop: "12px" }}>
      <table
        style={{
          borderCollapse: "collapse",
          width: "100%",
          minWidth: "1400px",
        }}
      >
        <thead>
          <tr>
            <th style={thStyle} rowSpan={2}>
              No.
            </th>
            <th style={thStyle} rowSpan={2}>
              Item PO
            </th>
            <th style={thStyle} rowSpan={2}>
              PO <br />
              (Pcs)
            </th>
            <th style={thStyle} rowSpan={2}>
              Berat <br />
              (gr)
            </th>
            <th style={thStyle} rowSpan={2}>
              Runner <br />
              (gr)
            </th>
            <th style={thStyle} rowSpan={2}>
              Pemakaian <br />
              (Kg)
            </th>
            <th style={thForecastGroupStyle} colSpan={4}>
              Forecast (Kg)
            </th>
            <th style={thUsageGroupStyle} colSpan={4}>
              Penggunaan Aktual (Kg)
            </th>
            <th style={thSelisihGroupStyle} colSpan={4}>
              Selisih (Kg)
            </th>
            <th style={thStyle} rowSpan={2}>
              Selisih Total <br />
              Pemakaian vs Aktual (Kg)
            </th>
          </tr>
          <tr>
            <th style={thForecastStyle}>W 1</th>
            <th style={thForecastStyle}>W 2</th>
            <th style={thForecastStyle}>W 3</th>
            <th style={thForecastStyle}>W 4</th>
            <th style={thUsageStyle}>W 1</th>
            <th style={thUsageStyle}>W 2</th>
            <th style={thUsageStyle}>W 3</th>
            <th style={thUsageStyle}>W 4</th>
            <th style={thStyle}>W 1</th>
            <th style={thStyle}>W 2</th>
            <th style={thStyle}>W 3</th>
            <th style={thStyle}>W 4</th>
          </tr>
        </thead>
        <tbody>
          {data.map((item, i) => {
            const berat = item.dataBarangJadi?.berat ?? 0;
            const runner = item.dataBarangJadi?.runner ?? 0;
            const jumlah = item.jumlah ?? 0;
            const totalBahan = (jumlah * (berat + runner)) / 1000;

            const { week1, week2, week3, week4 } = hitungBahanPerWeek(
              item.jadwalKirim,
              berat,
              runner
            );

            const materialKey = item.dataBarangJadi?.material; // materialGroup -> material
            const sudahTampil = materialKey && seenMaterials.has(materialKey);

            if (materialKey) seenMaterials.add(materialKey);

            const stockAwal = sudahTampil
              ? 0
              : item.dataBarangJadi?.stockAwalMaterial ?? 0;
            const week1Adjusted = week1 - stockAwal;

            const {
              week1: pw1,
              week2: pw2,
              week3: pw3,
              week4: pw4,
            } = sudahTampil
              ? { week1: 0, week2: 0, week3: 0, week4: 0 }
              : getPemakaianPerWeek(item.dataBarangJadi?.pemakaianMaterial);

            const forecastValues = [week1Adjusted, week2, week3, week4];
            const aktualValues = [pw1, pw2, pw3, pw4];

            const usageCellStyle = sudahTampil
              ? tdUsageMutedStyle
              : tdUsageStyle;

            const totalPemakaianAktual = pw1 + pw2 + pw3 + pw4;
            const { selisih: selisihTotal, style: selisihTotalStyle } =
              getSelisihInfo(totalBahan, totalPemakaianAktual, stockAwal);

            return (
              <tr key={item.id || i}>
                <td style={tdCenterStyle}>{i + 1}</td>
                <td style={tdLeftStyle}>{item.itemPo}</td>
                <td style={tdStyle}>{formatAngka(jumlah)}</td>
                <td style={tdStyle}>{formatAngka(berat)}</td>
                <td style={tdStyle}>{formatAngka(runner)}</td>
                <td style={tdStyle}>{formatAngka(totalBahan)}</td>
                <td
                  style={
                    week1Adjusted >= 0
                      ? tdForecastStyle
                      : tdForecastStyleAdaStock
                  }
                >
                  {formatAngka(week1Adjusted)}
                </td>
                <td style={tdForecastStyle}>{formatAngka(week2)}</td>
                <td style={tdForecastStyle}>{formatAngka(week3)}</td>
                <td style={tdForecastStyle}>{formatAngka(week4)}</td>
                <td style={usageCellStyle}>
                  {sudahTampil ? "-" : formatAngka(pw1)}
                </td>
                <td style={usageCellStyle}>
                  {sudahTampil ? "-" : formatAngka(pw2)}
                </td>
                <td style={usageCellStyle}>
                  {sudahTampil ? "-" : formatAngka(pw3)}
                </td>
                <td style={usageCellStyle}>
                  {sudahTampil ? "-" : formatAngka(pw4)}
                </td>
                {forecastValues.map((fVal, idx) => {
                  const aVal = aktualValues[idx];
                  const { selisih, style } = getSelisihInfo(fVal, aVal);
                  return (
                    <td key={idx} style={style}>
                      {sudahTampil ? "-" : formatAngka(selisih)}
                    </td>
                  );
                })}
                <td style={selisihTotalStyle}>
                  {sudahTampil ? "-" : formatAngka(selisihTotal)}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default MrpTable;
